<div class="row">
  <div class="col-12">
    <div class="gb-body3 heavy gb-color-grey-mid-dark mb-4">
      <p class="mb-0" [translate]="'locateDealer_requiredLabel'"></p>
    </div>
  </div>
</div>

<div class="row mb-4">
  <div class="col-12 col-lg-8">
    <div [trackLink]="'Dealer:BrandDropdown'" [trackDropdown]="'true'" [trackDelay]="'true'"
          [trackType]="'o'" [prop10]="'dealer:dropdown:'+brands[0]">
          <webu-select-input
            [id]="'DealerSearchBrandSelector'"
            [label]="'locateDealer_brandSelector_label'"
            [lov]="brands"
            [options]= "brands"
            [inputName]="'brandSelectorInput'"
            [isArray]="true"
            [required]="true"
            [formGroupInput]="dealerSearchForm"
            [formControlNameInput]="'brandSelectorInput'">
          </webu-select-input>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col-12 d-lg-flex" [formGroup]="dealerSearchForm" role="form" name="dealerSearchForm" novalidate>
    <div [trackLink]="'Dealer:ZipCode'" [trackDelay]="'true'" class="flex-grow-1 flex-shrink-0 mr-lg-3 col-8 pl-0" [trackType]="'o'" [prop10]="'dealer:textbox'" (keyup.enter)="search()">
        <ox-text-input
          [id]="'DealerSearchLocateDealer'"
          [type]="'text'"
          [inputName]="'searchInput'"
          [classes]="'form-control'"
          [required]="true"
          [placeHolderId]="'locateDealer_search_placeholder'"
          [label]="'locateDealer_search_label'"
          [ariaLabel]="'aoda_locateDealer_search_label'"
          [formGroupInput]="dealerSearchForm"
          [formControlNameInput]="'searchInput'">
        </ox-text-input>
    </div>
    <span [trackLink]="'Dealer:Search'" [trackDelay]="'true'" [trackType]="'o'"
          class="flex-grow-1 flex-shrink-0" [prop10]="'dealer:button:search'" [prop44]="prop44??''" [prop53]="prop53??''">
      <button type="submit" class="gb-primary-button mt-2 mt-lg-0" (click)="search()"
              [ngClass]="{'disabled': (!dealerSearchForm.valid)}"
              attr.aria-disabled="{{!dealerSearchForm.valid}}"
              aria-atomic="true" aria-live="assertive"
              [translate]="'locateDealer_findDealersBtn'">
      </button>
    </span>
  </div>
</div>
